import regionSunIcon from "../images/region-picker/solar-environment-256w-glow.png";
import regionIntSpaceIcon from "../images/region-picker/interplanetary-256w-glow.png";
import regionEarthMagIcon from "../images/region-picker/earth-magnetosphere-256w-glow.png";
import regionEarthAtmIcon from "../images/region-picker/earth-atmosphere-256w-glow.png";
import regionPlanetMagIcon from "../images/region-picker/planetary-magnetosphere-256w-glow.png";
import solarRollover from "../images/region-picker/background-1440w-1-solar-rollover.jpg";
import interplanetaryRollover from "../images/region-picker/background-1440w-1-interplanetary-rollover.jpg";
import earthMagRollover from "../images/region-picker/background-1440w-1-earthmag-rollover.jpg";
import earthAtmoRollover from "../images/region-picker/background-1440w-1-earthatmo-rollover.jpg";
import planetaryMagRollover from "../images/region-picker/background-1440w-1-planetarymag-rollover.jpg";

export const REGIONS = [
  {
    key: 'solar',
    link: '/region/sun',
    label: 'Solar Environment',
    iconClass: 'iconSolar',
    iconSrc: regionSunIcon,
    rolloverSrc: solarRollover,
  },
  {
    key: 'interplanetary',
    link: '/region/interplanetary-space',
    label: 'Interplanetary Space',
    iconClass: 'iconSpace',
    iconSrc: regionIntSpaceIcon,
    rolloverSrc: interplanetaryRollover,
  },
  {
    key: 'earthMag',
    link: '/region/earth-magnetosphere',
    label: 'Earth Magnetosphere',
    iconClass: 'iconMagnetosphere',
    iconSrc: regionEarthMagIcon,
    rolloverSrc: earthMagRollover,
  },
  {
    key: 'earthAtmo',
    link: '/region/earth-atmosphere',
    label: 'Earth Atmosphere',
    iconClass: 'iconAtmosphere',
    iconSrc: regionEarthAtmIcon,
    rolloverSrc: earthAtmoRollover,
  },
  {
    key: 'planetaryMag',
    link: '/region/planetary-magnetospheres',
    label: 'Planetary Magnetospheres',
    iconClass: 'iconPlanetary',
    iconSrc: regionPlanetMagIcon,
    rolloverSrc: planetaryMagRollover,
  },
];

export function getRegion(key) {
  return REGIONS.find((r) => r.key === key);
}
